import styled from 'styled-components';

import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 40px 50px;
  background-color: ${colors.shades.secondary10};
`;

const DateValueText = styled.span`
  color: ${({ $color }) => $color};
  font-weight: 500;
`;

export {
  Container,
  HeaderRow,
  DateValueText,
};
